<div class="mnc-notes">
  <router-outlet></router-outlet>
</div>